import React from 'react';
import PropTypes from 'prop-types';
import {WizTableForm, WizPreCondition as PreCondition} from '../../../common'
import {connect} from 'dva';
import {Input, Row, Col} from 'antd'
import {framework_tool, component_tool, utils_tool} from '@/tool'

let {WizContainer} = framework_tool;
let {WizCol, WizRow, WizCheckbox, WizRadio, WizSelect, WizIcon, WizTooltip, WizModal, WizButton} = component_tool;

const pml = 20; //间距

class ApplyStepsInfoLimit extends WizContainer {
  componentName = 'ApplyStepsInfoLimit';

  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,

  };

  /**
   * 监听父组件的值，当reset时收起问卷组件
   * @param  nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (nextProps.value != 2) {
      this.state = {
        showFlag: false,
        infoType: nextProps.value
      }
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      showFlag: true,
      infoType: props.value
    }
  }


  /**
   * 将值反馈给Form
   */
  onChangeInfo = (value) => {
    const {onChange} = this.props;
    let {target} = value;
    this.setState({
      infoType: target.value
    })
    onChange(target.value)
  }
  onChangeRowMap = (rowKey) => {
    let val = 0;
    for (i in rowKey) {
      if (rowKey[i] != null) {
        val = rowKey[i].id
        let surveyId = rowKey[i].id
        let surveyName = rowKey[i].title
        this.props.surveyId = surveyId
        this.props.surveyName = surveyName
      }
    }
    const {onChangeInfoId} = this.props;
    onChangeInfoId(val)
  }

   _time(time = +new Date()) {
    let date = new Date(time + 8 * 3600 * 1000); // 增加8小时
    return date.toJSON().substr(0, 19).replace('T', ' ');
  }

  showForm = () => {
    const{surveyId,surveyName} = this.props
    const surveyConfig = WizTableForm.Config.survey(this, {apiParams: {status: 1, type: 2, littleTime: this._time()}})
    const onChangeRowMap = this.onChangeRowMap
    let initRows = []
    if (surveyId && surveyName) {
      initRows = [{id: surveyId, title: surveyName}]
    }
    if (this.state.infoType == 1) {
    } else if (this.state.infoType == 2) {
      return (
        <Row>
          <Col span={10}>
            <WizTableForm
              title='问卷'
              {...surveyConfig}
              initRows={initRows}
              value={surveyId?surveyId:null}
              selectType='radio'
              showArrow={false}
              onChangeRowMap={onChangeRowMap}
            />
          </Col>
        </Row>

      )
    }
  }

  _render() {
    const {placeholder, value, ...otherProps} = this.props;
    const showForm = this.showForm
    return (
      <>
        <Row>
          <Col>
            <WizRadio.Group
              key={'infoType'}
              options={[{label: '无', value: 0}, {label: '文字信息', value: 1}, {label: '问卷收集', value: 2}]}
              value={value}
              onChange={(value) => this.onChangeInfo(value)}></WizRadio.Group>
            <WizTooltip title="此处关联问卷后，学员报名提交是要填写此问卷">
              <WizIcon type="question-circle-o"/>
            </WizTooltip>
          </Col>
        </Row>
        {
          showForm()
        }
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ApplyStepsInfoLimit);
